import React from 'react';

const DebugPanel = ({
  showPageNumbers,
  setShowPageNumbers,
  showPageImages,
  setShowPageImages
}) => {
  return (
    <div className="panel-content">
      <div className="input-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={showPageNumbers}
            onChange={(e) => setShowPageNumbers(e.target.checked)}
          />
          Print debug page numbers
        </label>
      </div>
      <div className="input-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={showPageImages}
            onChange={(e) => setShowPageImages(e.target.checked)}
          />
          Show page thumbnails
        </label>
      </div>
    </div>
  );
};

export default DebugPanel;
